import React from "react";
import Banner from "../../components/Banner";
// import Chart from "../components/Chart";
import { Link } from 'react-router-dom';
import Layout from '../../components/token/Layout';



const Home = () => {
  return (
    <>
       <Layout>
      <Banner />
      <div className='block-row radius-left-bottom'>
      <div className="container">
        <div className="about-row wow animate__animated animate__fadeInUp">
          <h2><strong>RizzNet is the preferred discount currency</strong> among participating merchants, providing real-world usability for millions of mobile subscribers worldwide.</h2>
        </div>
      </div>      
    </div>
    <div className='block-row  radius-left radius-btm-right pb-2x '  id="why-rizznet" >
      <div className="container">
        <div className="title-row  ">
          <h2>Why RizzNet?</h2>
        </div>
        <div className="flex why-area">
          <div className="item-box animate__flipInX  wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h3>Earn RZTO Tokens</h3>
              <p>through mobile usage
              (calls & data)</p>
            </div>
            <Link className='btn btn-arrow' rel="" type="" href=""><img src="/images/top-right.svg" alt="" /></Link> 
          </div>
          <div className="item-box animate__flipInX  wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h3>Spend <br />RZTO</h3>
              <p>with partnered online & offline merchants</p>
            </div>
            <Link className='btn btn-arrow' rel="" type="" href=""><img src="/images/top-right.svg" alt="" /></Link>
          </div>
          <div className="item-box animate__flipInX  wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h3>AI Currency  </h3>
              <p>Preffered currency for agentic AI interactions</p>
            </div>
            <Link className='btn btn-arrow' rel="" type="" href=""><img src="/images/top-right.svg" alt="" /></Link>
          </div>
          <div className="item-box animate__flipInX  wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h3>Staking & Rewards </h3>
              <p>to enhance token value and reduce supply</p>
              </div>
              <Link className='btn btn-arrow' rel="" type="" href=""><img src="/images/top-right.svg" alt="" /></Link>
          </div>
        </div>  
      
      </div>      
    </div>
    <div className="block-row" id="token-uility">
      <div className="container">
        <div className="title-row flex">
          <h3>Token Utility</h3>
          <Link className='btn btn-grey btn-lg utility-btn' rel="" type="" href="">For Merchants</Link> 
        </div>
        <div className="flex subscribe-block">
          <figure className="wow animate__animated animate__fadeInUp">
            <img src="/images/utility.jpg" alt="" />
          </figure>
          <div className="caption-area wow animate__animated animate__fadeInRight">
            <h3>For Subscribers</h3>
            <ul>
              <li>Get <strong>100 RZTO</strong> every time you <strong>renew 
              your mobile plan.</strong></li>
              <li>Earn <strong>1 RZTO</strong> per minute of calls & 
              5 RZTO per GB of data.</li>
              <li>Use tokens for <strong>discounts, rewards, 
              and merchant transactions.</strong></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div className="block-row bg-img-block radius-right" id="techno-stack">
      <div className="inner-block-row radius-left-middle">
        <div className="container">
          <div className="title-row">
            <h3>Technology Stack</h3>
          </div>
          <div className="flex tech-area">
            <div className="item-box wow animate__animated animate__fadeIn ">
              <div className="img-box">
                <figure>
                  <img src="/images/img-1.png" alt="" />
                  <p>Blockchain</p>
                </figure>
              </div>
              <div className="caption-area">
                <p>Secure, fast, & scalable transactions.</p>
              </div>
            </div>
            <div className="item-box wow animate__animated animate__fadeInUp">
              <div className="img-box">
                <figure>
                  <img src="/images/img-5.png" alt="" />
                  <p>Smart 
                  Contracts</p>
                </figure>
              </div>
              <div className="caption-area">
                <p>Automated, transparent, & tamper-proof.</p>
              </div>
            </div>
            <div className="item-box wow animate__animated animate__fadeIn">
              <div className="img-box">
                <figure>
                  <img src="/images/img-4.png" alt="" />
                  <p>AI-Based Rewards Engine</p>
                </figure>
              </div>
              <div className="caption-area">
                <p>Auto-staking & personalized incentives.</p>
              </div>
            </div>
            <div className="item-box wow animate__animated animate__fadeInUp">
              <div className="img-box">
                <figure>
                  <img src="/images/img-3.png" alt="" />
                  <p>Agentic AI 
                  for Merchants</p>
                </figure>
              </div>
              <div className="caption-area">
                <p>Smart merchants targeting via token-driven campaigns..</p>
              </div>
            </div>
            <div className="item-box wow animate__animated animate__fadeIn">
              <div className="img-box">
                <figure>
                  <img src="/images/img-2.png" alt="" />
                  <p>Decentralized Storage</p>
                </figure>
              </div>
              <div className="caption-area">
                <p>Immutable & verifiable data records.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="title-row">
          <h3>Circulation Reduction Strategies</h3>
        </div>
        <div className="flex strategi-area">
          <div className="item-box animate__flipInY  wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h5>Token Burns: </h5>
              <p>A portion of transactions and merchant fees are permanently burned</p>
            </div>
          </div>
          <div className="item-box animate__flipInY  wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h5>Staking & Lockups:</h5>
              <p>Users merchants must stake RZTO<br /> for premium<br /> benefits </p>
            </div>
          </div>
          <div className="item-box animate__flipInY  wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h5>Subscription Discounts:</h5>
              <p>Subscribers Get More Data by staking RZTO.</p>
            </div>
          </div>
          <div className="item-box animate__flipInY  wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h5>Governance Locking:</h5>
              <p>Participate in voting by locking tokens.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="block-row radius-right-middle pt-2x"  id="tokenomics">
      <div className="container">
        <div className="title-row">
          <h3>Tokenomics & Supply Management</h3>
        </div>
        <div className="flex chart-block">
          {/* <div className="chart-area wow animate__animated animate__fadeInUpBig">
            <Chart />
          </div> */}
          <div className="caption-area wow animate__animated animate__fadeInRightBig">
            <ul>
              <li className="main-item">
                <p>
                  <span>RZTO
                  <strong>200 Billion </strong>
                  </span>
                  Total Supply
                </p>
              </li>
              <li>Public Sale: 	10% (20B RZTO)</li>
              <li>Private Sales: 5% (10B RZTO)</li>
              <li>Liquidity: 5% (10B RZTO)</li>
              </ul>
          </div>
        </div>
      </div>
    </div>
    <div className="block-row radius-left-middle"  id="circulation">
      <div className="container">
        <div className="title-row">
          <h3>Circulation Reduction Strategies</h3>
        </div>
        <div className="flex reduction-area">
          <div className="item-box animate__flipInY wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h5>Token <br />Burns </h5>
              <p>A portion of transactions and merchant fees are permanently burned</p>
            </div>
          </div>
          <div className="item-box animate__flipInY wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h5>Staking & <br />Lockups</h5>
              <p>Users & merchants must stake RZTO for premium benefits</p>
            </div>
          </div>
          <div className="item-box animate__flipInY wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h5>Subscription <br />Discounts</h5>
              <p>Pay mobile bills in RZTO to reduce circulating supply.</p>
            </div>
          </div>
          <div className="item-box animate__flipInY wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h5>Governance <br />Locking</h5>
              <p>Participate in voting by locking tokens.</p>
            </div>
          </div>
          <div className="item-box animate__flipInY wow animate__animated animate__delay-1s">
            <div className="caption-area">
              <h5>Buyback <br />Model</h5>
              <p>RizzNet will buy back tokens from merchants & redistribute or burn them</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="block-row radius-btm-right bg-btm-right" style={{backgroundImage: "url(/images/footer-bg.png)" }}>
      <div className="container">
        <div className="title-row">
          <h3>Roadmap to Success</h3>
        </div>
        <div className="flex roadmap-area">
          <div className="item-box wow animate__animated animate__fadeInDown">
            <div className="caption-area">
              <h5>Phase 1 </h5>
              <p>Whitepaper Release & Partnerships</p>
            </div>
          </div>
          <div className="item-box wow animate__animated animate__fadeInUp">
            <div className="caption-area">
              <h5>Phase 2</h5>
              <p>Token Launch & Merchant Onboarding</p>
            </div>
          </div>
          <div className="item-box wow animate__animated animate__fadeInDown">
            <div className="caption-area">
              <h5>Phase 3</h5>
              <p>AI & Blockchain Development</p>
            </div>
          </div>
          <div className="item-box wow animate__animated animate__fadeInUp">
            <div className="caption-area">
              <h5>Phase 4</h5>
              <p>Full-Scale Deployment & Exchange Listings</p>
            </div>
          </div>
          <div className="item-box wow animate__animated animate__fadeInDown">
            <div className="caption-area">
              <h5>Phase 5</h5>
              <p>Building its own blockchain, allowing community projects.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    </Layout>
    </>
  );
};

export default Home;
